import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { useAuthContext } from "@charphq/ui/providers/auth-provider";

export const Route = createFileRoute("/")({
  component: function Index() {
    const { isAuthenticated, isLoading } = useAuthContext();
    const navigate = useNavigate();
    // Redirect exactly once. StrictMode double-invokes this mount effect
    // (setup → cleanup → setup); a second navigate() to the same code-split
    // route aborts the first route-chunk import and leaves it pending forever,
    // hanging the boot spinner. The ref survives the double-invoke so we fire once.
    const didRedirect = useRef(false);

    // Internal tool: the index is just a router. Signed in → dashboard;
    // signed out → the login screen. There is no marketing landing page.
    useEffect(() => {
      if (isLoading || didRedirect.current) return;
      didRedirect.current = true;
      navigate({ to: isAuthenticated ? "/dashboard" : "/auth", replace: true });
    }, [isAuthenticated, isLoading, navigate]);

    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary" />
      </div>
    );
  },
});
